import { createFileRoute } from "@tanstack/react-router";

import { CoachAutomationCreatePage } from "src/pages/CoachAutomationCreatePage";

export const Route = createFileRoute("/_auth/_coach/automations/new")({
  component: CoachAutomationCreatePage,
  ssr: true,
  staticData: {
    getBreadcrumb({ i18n }) {
      return {
        label: i18n.t("automationBuilder.createTitle"),
        href: "/automations/new",
      };
    },
  },
});
